import { plugin as engagementPlugin } from "@amplitude/engagement-browser"
import { AmplitudeEventType } from "~/types/global"

import { isValidEnvironment } from "./helpers"

let amplitudeEventsQueue = [] as AmplitudeEventType[]

const MAX_QUEUE_SIZE = 100

const amplitudeIgnoreEvents = ["Login Successful"]

export function amplitudeSetup({
  user,
  tenantId
}: {
  user: { id: string; name: string; email: string }
  tenantId: string
}) {
  if (
    !isValidEnvironment ||
    window.location.href.includes("dev.orbitshift.ai")
  ) {
    return
  }
  const isDev = import.meta.env.isDev === true
  const projectKey = isDev
    ? "dbea95b6acc65547ccf52724f56c13d8"
    : "554265e1e6d7c0638a9214a10afc0009"
  import("@amplitude/analytics-browser").then(async (amplitude) => {
    window.amplitude = amplitude
    const email = user?.email ?? ""
    await amplitude.init(projectKey, email, {
      sessionTimeout: 86400,
      identityStorage: "localStorage",
      serverUrl: "https://prodapi.orbitshift.ai/event-logs",
      logLevel: 0,
      useBatch: true,
      defaultTracking: {
        attribution: true,
        pageViews: false,
        sessions: false,
        formInteractions: false,
        fileDownloads: false
      }
    })
    amplitude.add(engagementPlugin())
    const event = new amplitude.Identify()
    if (email && tenantId) {
      event.set("tenant_id", tenantId)
      event.set("email", email)
      event.set("name", user.name)
      event.set("app_user_id", user.id)
    }
    amplitude.track("session_start", {
      page: window.location.pathname,
      timestamp: new Date().toISOString()
    })
    amplitude.identify(event).promise.then(() => {
      if (amplitudeEventsQueue.length > 0) {
        amplitudeEventsQueue.forEach((event) => {
          track(event.name, event.eventProperties)
        })
        amplitudeEventsQueue = []
      }
    })
  })
}

export async function track(
  name: string,
  eventProperties?: Record<string, any> | undefined
) {
  if (!name) return
  const sessionId = window.amplitude?.getSessionId?.()
  const userId = window.amplitude?.getUserId?.()
  if (amplitudeIgnoreEvents.includes(name)) {
    amplitudeEventsQueue.push({ name, eventProperties })
    if (amplitudeEventsQueue.length > MAX_QUEUE_SIZE) {
      amplitudeEventsQueue.shift()
    }
  }
  if (!isValidEnvironment || !sessionId || userId?.includes("orbitshift"))
    return
  if (!window.amplitude) {
    return
  }
  return window.amplitude.track(name, eventProperties).promise
}
